import { GET_WEIGHT_DISCREPANCY_AGGREGATE_SUCCESS, GET_WEIGHT_DISCREPANCY_AGGREGATE_REQUEST, GET_WEIGHT_DISCREPANCY_AGGREGATE_FAILURE, GET_WEIGHT_DISCREPANCY_AGGREGATE_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getWeightDiscrepancyAggregateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_WEIGHT_DISCREPANCY_AGGREGATE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_WEIGHT_DISCREPANCY_AGGREGATE_REQUEST:
            return Object.assign({}, state);
        case GET_WEIGHT_DISCREPANCY_AGGREGATE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_WEIGHT_DISCREPANCY_AGGREGATE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getWeightDiscrepancyAggregateReducer;
